import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20collage%2C%20dramatic%20lighting%2C%20manga%20characters%20in%20action%20poses%2C%20warm%20orange%20and%20deep%20red%20color%20palette%2C%20abstract%20comic%20panel%20background%2C%20dynamic%20composition%2C%20modern%20illustration%20style%2C%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=800&seq=hero-bg-main&orientation=landscape"
          alt="韩漫漫画网 - 韩漫在线阅读"
          className="w-full h-full object-cover object-top"
          title="韩漫漫画网 韩漫在线阅读 免费的韩国漫画"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 text-center font-heading leading-tight">
          <strong>韩漫漫画网</strong>
        </h1>
        <p className="text-base md:text-xl text-white/90 mb-2 text-center max-w-2xl">
          韩漫在线阅读的首选平台
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 text-center max-w-xl">
          畅享<strong>免费的韩国漫画</strong>和<strong>无删减下拉式韩漫大全</strong>，故事情节完整原汁原味
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-book-read-line mr-2"></i>开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 font-medium rounded-full hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-6 md:gap-10">
          {[
            { value: '3,000+', label: '收录韩漫' },
            { value: '500万+', label: '累计读者' },
            { value: '99.2%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}